import { render, staticRenderFns } from "./WarehouseDetail.vue?vue&type=template&id=44c84786"
import script from "./WarehouseDetail.vue?vue&type=script&lang=js"
export * from "./WarehouseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports